// Main JavaScript file for new functionality
// This file will be compiled to assets/theme.js
// Existing JS files in assets/ remain unchanged

// Import SCSS file
import './theme.scss';

// JavaScript for moving delivery estimator
document.addEventListener('DOMContentLoaded', function() {
  console.log('Carrols theme JavaScript loaded');
  
  // Move delivery estimator to pickup block
  moveDeliveryEstimator();
});

function moveDeliveryEstimator() {
  // Wait for the delivery estimator app to inject its content
  setTimeout(() => {
    const estimatorMessage = document.querySelector('.estimator-message');
    const deliveryEstimatorBlock = document.querySelector('.delivery-estimator-block');
    
    if (estimatorMessage && deliveryEstimatorBlock) {
      // Move the estimator message to the pickup block
      deliveryEstimatorBlock.appendChild(estimatorMessage);
      console.log('Delivery estimator moved to pickup block');
    } else {
      console.log('Delivery estimator elements not found', {
        estimatorMessage: !!estimatorMessage,
        deliveryEstimatorBlock: !!deliveryEstimatorBlock
      });
    }
  }, 2000); // Wait 2 seconds for the app to inject content
  
  // Also try moving it when the page is fully loaded
  window.addEventListener('load', () => {
    setTimeout(() => {
      const estimatorMessage = document.querySelector('.estimator-message');
      const deliveryEstimatorBlock = document.querySelector('.delivery-estimator-block');
      
      if (estimatorMessage && deliveryEstimatorBlock) {
        deliveryEstimatorBlock.appendChild(estimatorMessage);
        console.log('Delivery estimator moved to pickup block (on load)');
      }
    }, 1000);
  });
}

// Export functions for use in other files
// export { initNewComponents };
